import { observer } from 'mobx-react';
import LearningCollectionEditStore from '../../../../Store';
import { ProductLicenseResource } from '../../../../../../Types';
import ModalStore from '../../../../../../../Modal/Store';
import { fromEmpty } from 'maybeasy';
import ActiveProductLicense from './ActiveProductLicense';
import { CustomizeState } from '../../../../Store/Types';
import NoActiveProductLicenses from '../../../../../CurrentCollectionStep/ChooseProductLicense/Left/NoActiveProductLicenses';

interface Props {
  store: LearningCollectionEditStore;
  activeProductLicenses: ProductLicenseResource[];
  modalStore: ModalStore;
  state: CustomizeState;
  updateProductLicense: (productLicense: ProductLicenseResource) => void;
}

function ActiveProductLicenses({
  store,
  activeProductLicenses,
  modalStore,
  updateProductLicense,
  state,
}: Props) {
  return (
    <div data-intercom-target="edit-active-product-licenses-list">
      {fromEmpty(activeProductLicenses)
        .map((activeProductLicenses) => (
          <>
            {activeProductLicenses.map((activeProductLicense, index) => (
              <ActiveProductLicense
                key={activeProductLicense.payload.id}
                store={store}
                modalStore={modalStore}
                updateProductLicense={updateProductLicense}
                state={state}
                activeProductLicense={activeProductLicense}
                dataIntercomTarget={
                  index === 0 ? 'first-edit-active-product-license' : 'edit-active-product-license'
                }
              />
            ))}
          </>
        ))
        .getOrElse(() => (
          <NoActiveProductLicenses />
        ))}
    </div>
  );
}

export default observer(ActiveProductLicenses);
